import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Form, FormControl, Button, Col } from 'react-bootstrap'
import UploadImage from '../presentational-components/UploadImage';
import { addArticleTypeInputs } from '../../store/actions/index'
import { FetchGenders, FetchSizeCategories, FetchCreateArticle } from '../../fetcher'
import AlertMessage from '../presentational-components/AlertMessage';

const NewArticle = ({ dispatch, handleCloseModal, openAlert }) => {
    const [genders, setGenders] = useState([]);
    const [sizeCategories, setSizeCategories] = useState([]);

    useEffect(() => {
        FetchGenders(setGenders, openAlert)
    }, []);

    useEffect(() => {
        FetchSizeCategories(setSizeCategories, openAlert)
    }, []);

    let name
    let articleNumber
    let sizeCat
    let style
    let price
    let gender

    const [filename, setFilename] = useState("")
    const [image, setImage] = useState("")

    //const handleInput = () => {
    //    dispatch(addArticleTypeInputs(articleNumber.value, sizeCat.value, name.value, gender.value, style.value, price.value))
    //}

    const handleSubmit = (e) => {
        e.preventDefault()

        //const isValid = true
        //dispatch(addArticleTypeInputs(articleNumber.value, sizeCat.value, name.value, gender.value, style.value, price.value, isValid))
        console.log("Image: ")
        console.log(image)
        console.log(filename)

        const articleToCreate = {
            Name: name.value,
            ArticleNumberDesigner: articleNumber.value,
            DescriptionDesigner: style.value,
            Gender: gender.value,
            SizeCat: sizeCat.value,
            SizeCatSysId: sizeCategories.find(x => x.Category == sizeCat.value).CategorySysId,
            Price: price.value,
            FileName: filename,
            Image: image,
        };

        console.log("articleToCreate")
        console.log(articleToCreate)

        FetchCreateArticle(articleToCreate, handleCloseModal, openAlert)
    }

    return (
        <div lang="de">
            <Form onSubmit={handleSubmit} id='create-article-form'>

                <Form.Group controlId="article-select">

                    <div className="controlTitle">Artikelnummer:</div>
                    <FormControl required className="form" as="input" ref={node => articleNumber = node}></FormControl>

                    <div className="controlTitle">Größenkategorie:</div>
                    <FormControl required as="select" defaultValue="default" className="form"
                        focusFirstItemOnShow='keyboard' ref={node => sizeCat = node}>
                        <option disabled value="default">Größenkategorie...</option>
                        {sizeCategories.map(entry => 
                            <option>{entry.Category}</option>)
                        }
                        {/*{sizes.sizes.map(entry =>
                            <option>{entry.size}</option>)
                        } */}
                    </FormControl>

                    <div className="controlTitle">Name:</div>
                    <FormControl required className="form" as="input" ref={node => name = node} ></FormControl>

                    <div className="controlTitle">Geschlecht:</div>
                    <FormControl required as="select" defaultValue="default" className="form" 
                        focusFirstItemOnShow='keyboard' ref={node => gender = node}>
                        <option disabled value="default">Geschlecht...</option>
                        {genders.map(entry =>
                            <option>{entry}</option>)
                        }
                    </FormControl>

                    <div className="controlTitle">Beschreibung:</div>
                    <FormControl className="form" as="textarea" placeholder="Beschreibung..." ref={node => style = node}></FormControl>

                    <div className="controlTitle">Preis:</div>
                    <Form.Row size="sm" className="input-currency">
                        <Col><FormControl required className="form" type="number" min="0.00" step="0.01" placeholder="Preis in €..." ref={node => price = node}></FormControl> </Col>
                        <Col> <p className="input-currency-symbol">€</p> </Col>
                    </Form.Row>

                    <UploadImage setFilename={setFilename} setImage={setImage} />

                </Form.Group>
            </Form>
        </div>
    );
}

const testing = (prop) => {
    console.log("Sizes:")
    console.log(prop)
    return prop
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps)(NewArticle)